module.exports = __webpack_public_path__ + "img/services2.jpg?41bc953316e2d5a52f8c8c5ac047de64";